import { Component, Vue } from "vue-property-decorator";

@Component
export class PageSizeMixin extends Vue {
  public loading = false;
  public pageSize = {
    page: 1,
    size: 10,
  };
  public data = {};
  public mounted() {
    this.init();
  }
  public async init() {
    this.loading = true;
    const res = await (this as any).API({
      ...(this as any).formInline,
      ...this.pageSize,
    });
    if (res.code === 0) {
      this.data = res.data;
    }
    this.loading = false;
  }
  public changepage(i) {
    this.pageSize.page = i;
    this.init();
  }
  public sizeChange(i) {
    this.pageSize.size = i;
    this.changepage(1);
  }
}
